// extracted by mini-css-extract-plugin
export default {"notFoundSection":"NotFound_notFoundSection__nayJn","notFoundInnerSection":"NotFound_notFoundInnerSection__uOSlb","backToHomeBtn":"NotFound_backToHomeBtn__BocN0"};